import SpinReportView from "./SpinReportView";
import { apiPath } from "../../Utils/apiPath";

const SpinReport = () => (
  <SpinReportView
    title="Spin Report"
    endpoint={apiPath.spinReport}
    amountField="amount"
    amountLabel="Spin Win"
    fileName="spin-report"
  />
);

export default SpinReport;
